import Icon from '../components/Icon.vue'

Icon.register({
  baby: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M192 160c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM138.6 408.8l29.4 39.2c13.2 17.7 9.7 42.8-8 56-7.2 5.4-15.7 8-24 8-12.1 0-24.1-5.5-32-16l-48-64c-10.9-14.6-10.6-34.8 0.8-49l45.9-57.4 61.5 51.2zM281.3 325.6l45.9 57.4c11.4 14.2 11.7 34.4 0.8 49l-48 64c-7.8 10.5-19.8 16-32 16-8.4 0-16.8-2.6-24-8-17.7-13.2-21.2-38.3-8-56l29.4-39.2-25.6-32zM376.7 145c12.7 18.1 8.4 43-9.7 55.8l-40.6 28.5c-17 11.9-35.4 20.9-54.4 27.9v30.8h-160v-30.9c-19-7-37.4-16-54.4-27.9l-40.6-28.5c-18-12.7-22.4-37.6-9.7-55.7 12.7-18 37.6-22.4 55.7-9.7l40.6 28.4c52.6 37 124.1 37 176.8 0l40.6-28.5c18.1-12.6 43-8.3 55.7 9.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/baby.js
// module id = 635
// module chunks = 0